import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getDocumentRequestV2Async } from '../../../store/slices/additionalDocument/getDocumentRequestSliceV2';

const SHOW_ON_ROUTES = ['/app/dashboard'];

export default function useAdditionalDocumentPrompt() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { status, value } = useAppSelector(
    (state) => state.getDocumentRequestV2,
  );

  const { value: authValue } = useAppSelector((state) => state.auth);

  const { value: businessesValue } = useAppSelector(
    (state) => state.userBusinesses,
  );

  useEffect(() => {
    dispatch(getDocumentRequestV2Async());
  }, [dispatch]);

  const businessId = localStorage.getItem('businessId');

  const userHasAccount = authValue?.data?.user?.businesses?.find(
    (business) => business?.id === businessId,
  )?.hasAccount;

  const ownsAnyBusiness = businessesValue?.data?.some(
    (business) => business.creatorId === authValue?.data?.user?.id,
  );

  const hasPendingKybInfo =
    userHasAccount &&
    ownsAnyBusiness &&
    (authValue?.data?.user?.businessMember?.[0]?.hasCdd === false ||
      authValue?.data?.user?.businessMember?.[0]?.ninVerificationStatus ===
        'pending' ||
      authValue?.data?.user?.businessMember?.[0]?.ninVerificationStatus ===
        'rejected' ||
      authValue?.data?.user?.businessMember?.[0]?.addressVerificationStatus ===
        'pending' ||
      authValue?.data?.user?.businessMember?.[0]?.addressVerificationStatus ===
        'rejected');

  const hasOutstandingRequest =
    (status === 'success' &&
      !value?.data?.submitted &&
      Boolean(value?.data?.names?.length)) ||
    Boolean(hasPendingKybInfo);

  const showBanner =
    hasOutstandingRequest &&
    SHOW_ON_ROUTES.some((route) => location.pathname.includes(route));

  return { showBanner, reason: value?.data?.reason };
}
